import { IQuestionsGroupProps } from 'app/components/questions/base'
import { QuestionsGroupMediator } from 'app/components/questions/mediator'
import { Container } from 'app/containers/Container'
import { IQuestionsGroupContainerProps, QuestionsGroupContainer } from 'app/containers/PipelineSection/QuestionGroupContainer'
import { Profile } from 'app/redux/Profile/model'
import * as _ from 'lodash'

interface IProfileContainerState {
  profile: Profile
}

abstract class PensionQuestionsGroupContainer<P extends IQuestionsGroupContainerProps, S extends IProfileContainerState> extends QuestionsGroupContainer<P, S> {

  setStateAndSave<K extends keyof S>(state: Pick<S, K>, callback?: () => any) {
    this.markSignificantProfileUpdate(this.state.profile)
    this.setState(state, callback)
  }

}

export {
  IProfileContainerState,
  PensionQuestionsGroupContainer
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Pension/Container/index.tsx